export const LimitFiles = {
  'DEFAULT': 1,
  'CLOSING_DOCS': 5
};